import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

/**
 * ─────────────────────────────────────────────────────────────────────────────
 *  ACTIVATION DE COMPTE PROVISIONNÉ (flux public)
 * ─────────────────────────────────────────────────────────────────────────────
 *  validate : le lien d'activation est-il valide ? (aucune donnée sensible)
 *  complete : définition du mot de passe + auto-login (cookies de session).
 * ─────────────────────────────────────────────────────────────────────────────
 */
export const claimValidateSchema = z.object({
  token: z.string().min(10).max(256),
});
export class ClaimValidateDto extends createZodDto(claimValidateSchema) {}

export const claimCompleteSchema = z.object({
  token: z.string().min(10).max(256),
  password: z.string().min(8).max(72),
});
export class ClaimCompleteDto extends createZodDto(claimCompleteSchema) {}

export const claimValidateResultSchema = z.object({
  valid: z.boolean(),
  /** Prénom affiché à l'écran (aucun e-mail complet pour éviter l'énumération). */
  name: z.string().nullable().optional(),
  expiresAt: z.coerce.date().nullable().optional(),
});
export class ClaimValidateResultDto extends createZodDto(claimValidateResultSchema) {}
